import classNames from 'classnames';
import { OTPInput, REGEXP_ONLY_DIGITS } from 'input-otp';
import { FC } from 'react';

import { ExclamationMarkCircleIcon } from '../../../../icons';

interface OtpCodeInputProps {
  value: string;
  onChange: (value: string) => void;
  length?: number;
  error?: string | false;
  disabled?: boolean;
  name?: string;
}

const OtpCodeInput: FC<OtpCodeInputProps> = ({ value, onChange, length = 8, error = false, disabled, name }) => (
  <div>
    <OTPInput
      value={value}
      onChange={onChange}
      maxLength={length}
      disabled={disabled}
      name={name}
      inputMode="numeric"
      pattern={REGEXP_ONLY_DIGITS}
      autoComplete="one-time-code"
      pushPasswordManagerStrategy="none"
      containerClassName="flex gap-2"
      render={({ slots }) => (
        <>
          {slots.map(({ char, hasFakeCaret, isActive }, index) => (
            <div
              key={index}
              className={classNames(
                'flex h-14 w-12 items-center justify-center rounded-lg border-2 bg-white text-xl font-medium text-grey-900',
                disabled && 'opacity-50',
                error ? 'border-red-400' : isActive ? 'border-blue-500' : 'border-grey-300'
              )}
            >
              {char}
              {hasFakeCaret && <span className="h-5 w-px animate-pulse bg-grey-900" />}
            </div>
          ))}
        </>
      )}
    />
    {error && (
      <p className="mt-2 flex items-start gap-1 text-sm text-red-400 font-medium">
        <ExclamationMarkCircleIcon width={20} height={20} className="shrink-0 text-red-400 " />
        {error}
      </p>
    )}
  </div>
);

export default OtpCodeInput;
